module.exports = __webpack_public_path__ + "media/icons/lock-closed-213ed64e.svg";